import { cn } from "@/lib/utils";
import logoFullBlackWebp from "@/assets/logo-full-black.webp";
import logoIconBlackWebp from "@/assets/logo-icon-black.webp";
import logoVerticalSvg from "@/assets/logo-vertical.svg";


interface TicketHallLogoProps {
  variant?: "full" | "compact" | "symbol" | "vertical";
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  className?: string;
  imgClassName?: string;
}

const sizes = {
  sm: { full: "h-6", icon: "h-5" },
  md: { full: "h-8", icon: "h-6" },
  lg: { full: "h-10", icon: "h-8" },
  xl: { full: "h-12", icon: "h-10" },
  "2xl": { full: "h-14", icon: "h-12" },
};

const heightMap: Record<string, number> = {
  "h-5": 20,
  "h-6": 24,
  "h-8": 32,
  "h-9": 36,
  "h-10": 40,
  "h-12": 48,
  "h-14": 56,
  "h-16": 64,
  "h-20": 80,
};

export function TicketHallLogo({ variant = "full", size = "md", className, imgClassName }: TicketHallLogoProps) {
  const s = sizes[size] || sizes.md;
  const isSymbol = variant === "symbol" || variant === "compact";
  const h = isSymbol ? s.icon : s.full;

  const logoSrc = isSymbol 
    ? logoIconBlackWebp 
    : (variant === "vertical" ? logoVerticalSvg : logoFullBlackWebp);
  
  const isSquare = variant === "vertical" || isSymbol;
  const heightVal = heightMap[h] || 64;
  const widthVal = isSquare ? heightVal : Math.round(heightVal * (16 / 9));

  return (
    <span className={cn("inline-flex items-center", className)}>
      <img 
        src={logoSrc} 
        alt="TicketHall" 
        width={widthVal}
        height={heightVal}
        className={cn(h, "w-auto", imgClassName)} 
      />
    </span>
  );

}
